<template>
<div class="chapter">
<div class="inner_page">
<div class="ded">
<p class="center" id="start">For Linda, Evie, Mollie and Michael – always</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?2a865c10